import { Injectable } from '@angular/core';
import { ObjectStorage } from '@libs/libraries/shared';

import { ILegalCookiesBannerStorage } from './cookies-storage.interface';


@Injectable()
export class LegalCookiesBannerStorageHandler {

	constructor(
		private objectStorageHandler: ObjectStorage<ILegalCookiesBannerStorage>
	) {}


	/**------------------------------------------------------
	 * Check state
	 */
	hasAcceptedAll(): boolean {

		//0 - get social media and analytics cookies
		const hasSocialMediaCookies	: boolean = this.hasAcceptedSocialMedia();
		const hasAnalyticsCookies	: boolean = this.hasAcceptedAnalytics();

		//1 - return check if both the cookies are accepted
		return hasSocialMediaCookies && hasAnalyticsCookies;
	}

	hasSetToday(): boolean {

		//0 - get date on which user set previous cookie settings
		const setDate: Date = this.objectStorageHandler.getStorageObject('setDate');

		//1 - check if it was set today
		const hasSetToday: boolean = (new Date().getTime() - new Date(setDate).getTime()) / 86400000 < 1;

		//2 - return
		return hasSetToday;
	}


	/**------------------------------------------------------
	 * Save & Load Social Media Cookies
	 */
	hasAcceptedSocialMedia(): boolean {
		const isAllowed: boolean = this.objectStorageHandler.getStorageObject('socialMedia');
		return isAllowed;
	}

	setSocialMedia(isAllowed: boolean): void {
		this.objectStorageHandler.setStorageObject('socialMedia', isAllowed);
		this.setDate();
	}


	/**------------------------------------------------------
	 * Save & Load Analytics Cookies
	 */
	hasAcceptedAnalytics(): boolean {
		const isAllowed: boolean = this.objectStorageHandler.getStorageObject('analytics');
		return isAllowed;
	}

	setAnalytics(isAllowed: boolean): void {
		this.objectStorageHandler.setStorageObject('analytics', isAllowed);
	}


	/**------------------------------------------------------
	 * Helper Functions
	 */
	setDate(): void {
		this.objectStorageHandler.setStorageObject('setDate', new Date());
	}
}
